<template>
    <v-app>
        
        <v-main>
            <v-btn
                absolute
                top
                right
                text
                color="primary"
                outlined
                @click="closeApplication"
                class="d-none d-md-flex"
            >
                Close Application
            </v-btn>
            <v-fab-transition>
                
                <v-btn
                    fab
                    color="primary"
                    dark
                    absolute
                    top
                    right
                    small
                    class="d-flex d-sm-none"
                    style="z-index:3; position:fixed"
                    @click="closeApplication"
                >
                    <v-icon
                        small
                    >mdi-close</v-icon>
                </v-btn>
            </v-fab-transition>            
            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="700"
                        flat
                    >  
                        
                        <v-img
                            :src="require('../assets/logo.png')"
                            contain
                            height="70"
                        />
                        <h1 class="primary--text  font-weight-bold">
                            Arima North Secondary School
                        </h1>
                        <div class="text-h6 font-weight-light primary--text">
                            Arima Old Road, Arima
                        </div>
                        <div class="mt-4 primary--text font-weight-bold text-h5">
                            {{ applicationYear }} APPLICATION FORM FOR ENTRY INTO FORM SIX (6)
                        </div>
                        
                    </v-card>
                    <!-- <v-card            
                        width="550"
                        flat
                    >
                        <v-alert
                                
                            type="error"
                            class="mt-4"

                            text
                            outlined
                        >
                            Please 
                            <v-btn 
                                class="mx-3" 
                                color="red" 
                                dark
                                @click="showInstructions"
                            >
                                Click to Read
                            </v-btn>
                            instructions before proceeding.
                        </v-alert>

                        
                    </v-card>  -->
                </v-col>
            </v-row>

            <v-row class="">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card width="550" flat>
                        <v-alert
                            border="left"
                            colored-border
                            type="info"
                            class="mt-4 text-justify"
                            color="primary"
                            text
                            outlined
                        >
                            Application ID# <strong>{{ recordApplication.application_id }}</strong>
                            <!-- The deadline for completing your application is <strong>Wednesday 20th October 2021</strong> -->
                            You can check the status of your application by generating your application form.
                        </v-alert>
                    </v-card>
                    <v-card            
                        width="550"
                        class="mt-10"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            STUDENT INFORMATION
                        </v-card-title>
                        
                    </v-card>
                </v-col>
            </v-row>

            <v-row
                align="center"
                justify="center"
            >
                <v-card
                    class="pa-6 mt-5" 
                    width="550"
                >
                    <v-row 
                        align="center"
                        justify="center"
                        v-for="(field, index) in fields"
                        :key="index"
                    >
                        <v-col
                            cols="12"                       
                        >
                            <date-picker
                                v-if="field.type == 'date'"
                                v-bind:label="field.label"
                                v-bind:date="recordApplication[field.model]"
                                v-on:change-date="updateDate"
                                v-bind:saveStatus="field.saveStatus"
                            ></date-picker>

                            <v-text-field
                                v-else-if="field.type == 'email'"
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @blur="validate(field, 'application')"
                                :prepend-icon="field.icon"                            
                                autocomplete="false"
                                counter
                                :maxlength="field.maxlength" 
                                :ref="field.ref" 
                                :rules="[() => regex.test(recordApplication[field.model]) || 'Invalid e-mail' ]"                           
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>

                            <v-text-field
                                v-else-if="field.type == 'phone'"
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @blur="validate(field, 'application')"
                                @keypress="numberOnly"
                                :prepend-icon="field.icon"
                                placeholder=" "
                                hint="Enter 7 digits only"
                                persistent-hint
                                prefix="1868"
                                maxlength="7"
                                autocomplete="none"
                                :ref='field.ref'
                                :rules="[() => recordApplication[field.model] && recordApplication[field.model].length == 7 || '7 Digits Needed']"                                                  
                            >
                                 <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>

                            <v-select
                                v-else-if="field.type == 'select'"
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @blur="validate(field, 'application')"
                                :prepend-icon="field.icon"                            
                                autocomplete="none"
                                :counter="field.counter"
                                :maxlength="field.maxlength" 
                                :disabled="field.disabled"
                                :filled="field.filled"
                                :items="field.items"
                                :ref="field.ref"
                                hide-details       
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-select>

                             <v-text-field
                                v-else-if="field.type == 'number'"
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @blur="validate(field, 'application')"
                                :prepend-icon="field.icon"                            
                                autocomplete="none"
                                type="number"
                                min=0
                                max="10"
                                oninput="if(Number(this.value) > this.max) this.value = this.max; else if(Number(this.value) < this.min) this.value = this.min"
                                :disabled="field.disabled"
                                :filled="field.filled"
                                :ref="field.ref"
                                hide-details       
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>

                            <v-text-field
                                v-else
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @blur="validate(field, 'application')"
                                :prepend-icon="field.icon"                            
                                autocomplete="none"
                                :counter="field.counter"
                                :maxlength="field.maxlength" 
                                :disabled="field.disabled"
                                :filled="field.filled"
                                :ref="field.ref"
                                hide-details       
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>     
                </v-card>
            </v-row>

            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            <div>CSEC SUBJECTS</div>
                        </v-card-title>

                        <v-card-text>
                            <v-alert
                                border="left"
                                colored-border
                                type="info"
                                class="mt-4 text-justify"
                                color="primary"
                                text
                                outlined
                            >
                                Subjects done at CSEC Level in the order given on the results slip
                            </v-alert>

                            <v-data-table
                                :headers="headers"
                                :items="subjects"
                                hide-default-footer
                                hide-default-header
                            >
                                <template v-slot:header="{ props: { headers } }">
                                    <thead>
                                        <tr>
                                            <th style="width:280px">
                                                <div class="text-h6">
                                                    {{ headers[0].text }}
                                                </div>
                                                <div class="text-caption">
                                                    {{ headers[0].subtext }}
                                                </div>
                                            </th>
                                            <th>
                                                <div class="text-h6">
                                                    {{ headers[1].text }}
                                                </div>
                                                <div class="text-caption">
                                                    {{ headers[1].subtext }}
                                                </div>
                                            </th>
                                            <th>
                                                <div class="text-h6">
                                                    {{ headers[2].text }}
                                                </div>
                                                <div class="text-caption">
                                                    {{ headers[2].subtext }}
                                                </div>
                                            </th>
                                            <th
                                                style="width:30"
                                            ></th>
                                        </tr>
                                    </thead>
                                </template>

                                <template v-slot:item="props">
                                    <tr>
                                        <td>
                                            <v-autocomplete
                                                v-model="props.item.id" 
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Subject"
                                                :items="csecSubjects"
                                                item-text="title"
                                                item-value="id"
                                                @change="updateCsecGrade(props.index)"                                              
                                            ></v-autocomplete>
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="props.item.grade" 
                                                :items="grades"
                                                outlined
                                                dense
                                                hide-details
                                                @change="updateCsecGrade(props.index)"  
                                            ></v-select>
                                        </td>
                                        <td>
                                            <v-text-field
                                                v-model="props.item.profiles"
                                                outlined
                                                dense
                                                hide-details
                                                class="font-weight-bold uppercase-input"
                                                @input="toUpperCase(props)"
                                                @change="updateCsecGrade(props.index)"  
                                            ></v-text-field>
                                        </td>
                                        <td>
                                            <v-fade-transition>
                                                <v-progress-circular
                                                    v-if="props.item.saveStatus.saving"
                                                    size="16"
                                                    width="3"
                                                    color="info"
                                                    indeterminate
                                                ></v-progress-circular>
                                            </v-fade-transition>

                                            <v-fade-transition>    
                                                <v-icon
                                                    v-if="props.item.saveStatus.saveSuccess"
                                                    small
                                                    color="info"                                        
                                                >
                                                    mdi-check-all
                                                </v-icon>
                                            </v-fade-transition>

                                            <v-fade-transition>    
                                                <v-icon
                                                    v-if="props.item.saveStatus.saveError"
                                                    small
                                                    color="red"                                        
                                                >
                                                    mdi-alert-circle
                                                </v-icon>
                                            </v-fade-transition>  
                                                
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>

            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            <div>CHOICE OF ADVANCED LEVEL SUBJECT</div> 
                            
                        </v-card-title>
                        <v-card-text>
                            <v-alert
                                border="left"
                                colored-border
                                type="info"
                                class="mt-4 text-justify"
                                color="primary"
                                text
                                outlined
                            >
                                Choose <strong>three</strong> subjects from the three lines below.
                                Only <strong>One</strong> Subject can be chosen from EACH line.
                                There is a first choice and a second choice. Please select subjects for both choices.
                            </v-alert>

                            <v-alert                                    
                                type="info"
                                class="mt-4 text-justify"
                                border="left"
                                colored-border
                                text
                                outlined
                            >
                                Please 
                                <v-btn 
                                    class="mx-3" 
                                    color="primary" 
                                    dark
                                    @click="showPrerequisites"
                                >
                                    Click to Read
                                </v-btn>
                                subject prerequisites before choosing.
                            </v-alert>

                        </v-card-text>

                        <v-card-text>
                            <v-alert
                                text
                                color="primary"
                                dense
                                border="left"
                                colored-border
                            >
                                CAPE Subjects 1st Choice
                            </v-alert>
                            <v-data-table
                                :headers="headersSubjectChoice1"
                                :items="subjectChoices1"
                                hide-default-footer
                                hide-default-header
                            >
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>
                                            {{ item.line }}
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="subjectsChoice1[item.line]"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Subject"
                                                :items="item.subjects"
                                                item-text="subject_title"
                                                item-value="subject_title"
                                                @change="updateSubjectChoice(1, item)"                                                 
                                            >
                                                <template v-slot:append-outer>
                                                    <v-fade-transition>
                                                        <v-progress-circular
                                                            v-if="item.saveStatus.saving"
                                                            size="16"
                                                            width="3"
                                                            color="info"
                                                            indeterminate
                                                        ></v-progress-circular>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveSuccess"
                                                            small
                                                            color="info"                                        
                                                        >
                                                            mdi-check-all
                                                        </v-icon>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveError"
                                                            small
                                                            color="red"                                        
                                                        >
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </v-fade-transition>
                                                </template>
                                            </v-select>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>

                            <v-alert
                                text
                                color="primary"
                                dense
                                border="left"
                                colored-border
                                class="mt-4"
                            >
                                CAPE Subjects 2nd Choice
                            </v-alert>

                            <v-data-table
                                :headers="headersSubjectChoice2"
                                :items="subjectChoices2"
                                hide-default-footer
                                hide-default-header
                            >
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>
                                            {{ item.line }}
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="subjectsChoice2[item.line]"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Subject"
                                                :items="item.subjects" 
                                                item-text="subject_title"
                                                item-value="subject_title"
                                                @change="updateSubjectChoice(2, item)"                                              
                                            >
                                                <template v-slot:append-outer>
                                                    <v-fade-transition>
                                                        <v-progress-circular
                                                            v-if="item.saveStatus.saving"
                                                            size="16"
                                                            width="3"
                                                            color="info"
                                                            indeterminate
                                                        ></v-progress-circular>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveSuccess"
                                                            small
                                                            color="info"                                        
                                                        >
                                                            mdi-check-all
                                                        </v-icon>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveError"
                                                            small
                                                            color="red"                                        
                                                        >
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </v-fade-transition>
                                                </template>
                                            </v-select>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>

             <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            <div>DOCUMENTS UPLOAD</div> 
                            
                        </v-card-title>
                        <v-card-text>
                            <v-alert
                                border="left"
                                colored-border
                                type="info"
                                class="mt-4 text-justify"
                                color="primary"
                                text
                                outlined
                            >
                                Please upload scanned copies of the required documents. Documents must be in <strong>PDF</strong> format.
                                The passport photo must be either <strong>JPEG</strong> or <strong>PNG</strong> format. Alternatively you can drop hard copies of the documents to the school's office
                            </v-alert>
                            
                        </v-card-text>                      
                        
                    </v-card>
                </v-col>
            </v-row>

            <v-row 
                class="mt-4"
                v-for="document in documents"
                :key="document.label"
            >
                <v-col
                    align="center"
                    justify="center"
                >
                    <upload-file
                        v-bind:fileLabel="document.label"
                        v-bind:fileType="document.type"
                    ></upload-file>
                </v-col>
            </v-row>

            <v-row class="mt-4">
                 <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-btn
                            block
                            color="primary"
                            @click="submitApplicationForm"
                        >
                            Submit Application Form
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row> 

            <!-- <v-row class="mt-4">
                 <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  s
                        <v-btn
                            block
                            color="primary"
                            @click="displayApplicationForm"
                        >
                            Generate Application Form
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>        -->
        </v-main>

        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>

        <v-dialog
            v-model="dialogSubmit"
            width="400"
            persistent
        >
            <v-card>
                <v-card-title class="text-center">
                    <span class="mx-auto">Application Successfully Submitted</span>
                </v-card-title>
                <v-card-text>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                    </svg>
                </v-card-text>

                <v-card-actions class="flex-column">
                        <v-btn
                            color="primary"
                            outlined
                            @click="displayApplicationForm"
                            class="text-capitalize"
                            block
                        >
                            Click to Generate Application Form
                        </v-btn>
                        <v-btn 
                            depressed 
                            block 
                            class="my-4" 
                            @click="dialogSubmit = false"
                        >
                            Close
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>>

        <v-dialog
            v-model="dialogReport"                      
            persistent
        >
           <v-card height="80vh">
            <iframe ref="pdf" style="width:100%; height:100%" frameBorder="0" :src="src"></iframe>
           </v-card>

            <v-container
                fluid
                class="pa-0"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >

                        <v-btn
                            color="primary"
                            dark
                            @click="closeRegistrationForm"
                            class="my-2 mr-4"
                        >
                            Close
                        </v-btn>

                    </v-row>
                </v-sheet>
            </v-container>

        </v-dialog>

         <v-dialog
            v-model="dialogError"
            width="400"
            persistent
        >
            <v-card class="error-card" rounded="lg">
                <v-card-text class="pt-6 pb-2 text-center">
                    <v-avatar color="red lighten-5" size="64" class="mb-4">
                    <v-icon color="red darken-2" size="32">mdi-alert-circle-outline</v-icon>
                    </v-avatar>

                    <div class="text-h6 font-weight-bold mb-1">
                        {{ title }}
                    </div>

                    <div class="text-body-2 grey--text text--darken-1">
                        {{ message }}
                    </div>

                    <v-expand-transition v-if="details">
                        <div  class="error-details mt-3 text-left">
                            <pre class="text-caption mb-0 text-center font-weight-bold" style="text-wrap:auto;">{{ details }}</pre>
                        </div>
                    </v-expand-transition>
                    
                </v-card-text>

                <v-card-actions class="pb-4 px-6 justify-center">
                    
                    <v-btn
                        color="red darken-2"
                        class="white--text"
                        depressed
                        block
                        @click="dialogError = false"
                    >
                    Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>>
    </v-app>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import DatePicker from '../components/DatePicker.vue';
import UploadFile from '../components/UploadFiles.vue';
export default {
    created: function () {
        this.initialize();
    },

    components: {
        DatePicker,
        UploadFile
    },

    data: function () {
        return {
            fields: [
                {
                    label: 'CSEC Candidate Number', 
                    model: 'csec_registration_number', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'csecRegistrationNumber',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'First Name', 
                    model: 'first_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'firstName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Last Name', 
                    model: 'last_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'lastName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },                    
                    record: 'application',
                },
                {
                    label: 'Address', 
                    model: 'address', 
                    type: 'textArea', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'address',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Birth Certificate Pin', 
                    model: 'birth_certificate_pin', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'birthCertificatePin',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Gender', 
                    model: 'gender', 
                    type: 'select', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'gender',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },
                    items: ['Male', 'Female'], 
                    record: 'application',
                },
                {
                    label: 'Date of Birth', 
                    model: 'date_of_birth', 
                    type: 'date', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'dateOfBirth',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Email (Student)', 
                    model: 'email', 
                    type: 'email', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'email',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Telephone Contact Student (Mobile)', 
                    model: 'phone_mobile', 
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneMobile',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },   
                {
                    label: 'Previous School', 
                    model: 'previous_school', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'previousSchool',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'How many years were you at this school', 
                    model: 'number_of_years_previous', 
                    type: 'number', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'previousSchool',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'School Type (Public/Private)', 
                    model: 'school_type_previous', 
                    type: 'select', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'previousSchool',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },
                    items: ["Public", "Private"], 
                    record: 'application',
                },
                            
                {
                    label: 'What other school did you attend (If Applicable)', 
                    model: 'other_school', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'previousSchool',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'How many years were you at this school', 
                    model: 'number_of_years_other', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'previousSchool',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'School Type', 
                    model: 'school_type_other', 
                    type: 'select', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'previousSchool',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },
                    items: ["Public", "Private"], 
                    record: 'application',
                },
                           
                
                {
                    label: "Father's Name", 
                    model: 'father_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Telephone Contact Father', 
                    model: 'phone_mobile_father', 
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneHomeParent',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: "Mother's Name", 
                    model: 'mother_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Telephone Contact Mother', 
                    model: 'phone_mobile_mother', 
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneMobileParent',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: "Guardian's Name", 
                    model: 'guardian_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Telephone Contact Guardian', 
                    model: 'phone_mobile_guardian', 
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'phoneMobileParent',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Email (Parent)', 
                    model: 'email_parent', 
                    type: 'email', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'emailParent',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
            ],
            recordApplication: {},
            recordApplicationGrades: {},
            recordApplicationSubjectChoices: {},
            headers: [
                { text: 'SUBJECTS', subtext: ' ', value: 'subject'},
                { text: 'GRADE', subtext: '(I,II,III)', value: 'grade'},
                { text: 'PROFILE', subtext: '(e.g. A,B,A)', value: 'profile'},
                { text: '', subtext: ''},
            ],
            subjects: [
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                
               
            ],
            csecSubjects: [],
            grades: [
                'I','II','III','IV','V','VI'
            ],
            headersSubjectChoice1: [
                {text: ''},               
                {text: 'OPTION 1'},               
            ],
            headersSubjectChoice2: [
                {text: ''}, 
                {text: 'OPTION 2'},               
            ],

            subjectChoices1:[
                {
                    line: 1, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },             
                {
                    line: 2, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },          
                {
                    line: 3, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
            ],
            subjectChoices2:[
                {
                    line: 1, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },             
                {
                    line: 2, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },          
                 {
                    line: 3, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
            ],
            overlay: false,

            subjectsChoice1:{},

            subjectsChoice2:{},

            src: '',

            dialogReport: false,

            documents: [
                {
                    label: 'Birth Certificate', 
                    placeholder: 'Upload your birth certificate', 
                    type: 'birth_certificate',
                    ref: 'birth_certificate',
                },
                {
                    label: 'CSEC Results Slip', 
                    placeholder: 'Upload your CSEC results slip', 
                    type: 'results_slip',
                    ref: 'results_slip',
                },
                {
                    label: 'Passport Photo', 
                    placeholder: 'Upload Passport Photo', 
                    type: 'picture',
                    ref: 'picture',
                },
                {
                    label: 'Transfer Form', 
                    placeholder: 'Upload Transfer Form', 
                    type: 'transfer_form',
                    ref: 'transferForm',
                },
                {
                    label: 'Recommendation', 
                    placeholder: 'Upload Recommendation', 
                    type: 'recommendation_1',
                    ref: 'recommendation1',
                },
                {
                    label: 'Immunization Card', 
                    placeholder: 'Upload Immunization Card', 
                    type: 'immunization_card',
                    ref: 'immunization_card',
                },
                {
                    label: 'Passport (Foreign Born Students)', 
                    placeholder: 'Upload Passport', 
                    type: 'passport',
                    ref: 'passport',
                },
            ],

            applicationYear: null,
            dialogSubmit: false,
            dialogError: false,
            errorMessage: '',
            title: 'Error', 
            message: 'Please check the information in the field: ',
            details: null,
        }
    },

    computed: {
        ...mapGetters({
            application: 'application/getApplication',
            applicationGrade: 'application/getApplicationGrade',
        }),

        regex(){
            return new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) 
        },

        
    },

    methods: {
        async initialize () {
            this.overlay = true;
            this.recordApplication = JSON.parse(sessionStorage.getItem('application'));
            // this.recordApplication = JSON.parse(this.application);
            this.setApplication(this.recordApplication);
            try {
                const promiseApplication = this.getApplication();
                const promiseSubjectLines = this.getSubjectLines();
                const promiseApplicationSubjectChoices = this.getApplicationSubjectChoices();
                const promiseCsecSubjects = this.getCsecSubjects();
                const promiseApplicationSubjectGrades = this.getApplicationSubjectGrades();
                const promiseApplicationsLockStatus = this.getApplicationsLockStatus();
                const promiseCurrentApplicationPeriod = this.getCurrentApplicationPeriod();

                const[
                    { data: dataApplication},
                    { data: dataSubjectLines},
                    { data: dataSubjectChoices },
                    { data: dataCsecSubjects },
                    { data: dataSubjectGrades },
                    { data: dataApplicationsLockStatus },
                    { data: dataCurrentApplicationPeriod }
                ] = await Promise.all([
                    promiseApplication,
                    promiseSubjectLines,
                    promiseApplicationSubjectChoices,
                    promiseCsecSubjects,
                    promiseApplicationSubjectGrades,
                    promiseApplicationsLockStatus,
                    promiseCurrentApplicationPeriod
                ])
                
                this.recordApplication = dataApplication;
                this.mapSubjectLines(dataSubjectLines);
                this.mapSubjectChoices(dataSubjectChoices);
                this.csecSubjects = dataCsecSubjects;
                this.mapCsecGrades(dataSubjectGrades);
                this.mapApplicationLock(dataApplicationsLockStatus);
                this.setApplicationYear(dataCurrentApplicationPeriod.year)
                this.applicationYear = dataCurrentApplicationPeriod.year
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.overlay = false;
            // this.showInstructions();
        },

        ...mapMutations({
            setApplication: 'application/setApplication',
            setApplicationSubjectChoice: 'application/setApplicationSubjectChoice',
            setApplicationGrade: 'application/setApplicationGrade',
            setApplicationYear: 'application/setApplicationYear',
        }),

        ...mapActions({
            postApplication: 'application/postApplication',
            postApplicationGrade: 'application/postApplicationGrade',
            postApplicationSubjectChoice: 'application/postApplicationSubjectChoice',
            getApplication: 'application/getApplication',
            getSubjectLines: 'application/getSubjectLines',
            getApplicationSubjectChoices: 'application/getApplicationSubjectChoices',
            getCsecSubjects: 'application/getCsecSubjects',
            getApplicationSubjectGrades: 'application/getApplicationSubjectGrades',
            getInstructionsURL: 'application/getInstructionsURL',
            getPrerequisitesURL: 'application/getPrerequisitesURL',
            getApplicationsLockStatus: 'application/getApplicationsLockStatus',
            getCurrentApplicationPeriod: 'application/getCurrentApplicationPeriod',
        }),

        mapSubjectLines (data) {
            this.subjectChoices1.forEach(choice => {
                switch (choice.line){
                    case 1:
                        choice.subjects = data[1];
                        break;
                    case 2:
                        choice.subjects = data[2];
                        break;
                    case 3:
                        choice.subjects = data[3];
                        break;
                }
            });

            this.subjectChoices2.forEach(choice => {
                switch (choice.line){
                    case 1:
                        choice.subjects = data[1];
                        break;
                    case 2:
                        choice.subjects = data[2];
                        break;
                    case 3:
                        choice.subjects = data[3];
                        break;
                }
            });
        },

        mapSubjectChoices (data) {
            data.forEach(value => {
                if(value.choice == 1){
                    this.subjectsChoice1[value.line] = value.subject_title;
                }
                else if(value.choice == 2){
                    this.subjectsChoice2[value.line] = value.subject_title;
                }
            })
        },

        mapCsecGrades (data) {
            data.forEach((value,index) => {
                this.subjects[index].id = value.subject_id;
                this.subjects[index].grade = value.grade;
                this.subjects[index].profiles = value.profiles
            })
        },

        validate (field, record) {
            // console.log(field)
            switch (record) {
                case 'application':
                    if(this.recordApplication[field.model]){
                        this.update(record, field)
                    }
            }
        },

        update (record, field) {
            switch (record) {
                case 'application':
                    this.updateApplication(field);
                    break;

            }    
        },

        async updateApplication (field) {
            console.log(field);
            this.setSaveStatus(field);
            try {
                this.setApplication(this.recordApplication);
                const response = await this.postApplication();
                console.log(response);
                this.setSaveStatus(field, 'saveSuccess');
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.details = `"${field.label}"`;
                this.dialogError = true;
                this.setSaveStatus(field, 'saveError');  
            }
        },

        updateSubjectChoice (choice, field) {
            this.setSaveStatusSubjectChoice (choice, field.line, 'saving');
            let subjectChoice = {};
            if(choice == 1 && this.subjectsChoice1[field.line]){
                subjectChoice = {
                    application_id: this.recordApplication.application_id,
                    year: this.recordApplication.year,
                    subject_title: this.subjectsChoice1[field.line],
                    line: field.line,
                    choice: 1
                }
            }
            if(choice == 2 && this.subjectsChoice2[field.line]) {
                 subjectChoice = {
                    application_id: this.recordApplication.application_id,
                    year: this.recordApplication.year,
                    subject_title: this.subjectsChoice2[field.line],
                    line: field.line,
                    choice: 2
                }
            }
            this.setApplicationSubjectChoice(subjectChoice);
            this.saveSubjectChoice(choice, field.line,);
        },

        mapApplicationLock ({ locked }) {
            console.log(locked);
            if(locked){
                this.fields.forEach(f => {
                    f.disabled = true;
                });
                this.subjects.forEach(s => {
                    s.disabled = true;
                });
                this.subjectChoices1.forEach(c => {
                    c.disabled = true;
                })
                this.subjectChoices2.forEach(c => {
                    c.disabled = true;
                })
                this.documents.forEach(d => {
                    d.disabled = true;
                })
            }
        },

        async saveSubjectChoice (choice, line,) {
            try {
                const response = await this.postApplicationSubjectChoice();
                console.log(response);
                this.setSaveStatusSubjectChoice (choice, line, 'saveSuccess');
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSaveStatusSubjectChoice (choice, line, 'saveError');
            }
        },

        updateDate (date) {
            console.log(date);
            this.recordApplication.date_of_birth = date;
            let dateOfBirthField = this.fields.filter(field => field.model == 'date_of_birth')[0]
            this.update('application', dateOfBirthField);
        },

        updateCsecGrade (index) {
            if(
                this.subjects[index].id &&
                this.subjects[index].grade &&
                this.subjects[index].profiles
            ){
                let subjectId = this.subjects[index].id;
                let grade = this.subjects[index].grade;
                let profiles = this.subjects[index].profiles.toUpperCase();
                this.setApplicationGrade({
                    application_id: this.recordApplication.application_id,
                    year: this.recordApplication.year,
                    subject_id: subjectId,
                    grade: grade,
                    profiles: profiles,
                    examination_year: null
                });
                this.saveCsecGrade(index);
            }
        },

        async saveCsecGrade (index) {
            console.log('saving grade record');
            console.log(this.applicationGrade);
            this.setSaveStatusSubjectGrade (index, 'saving')
            try {
                const response = await this.postApplicationGrade();
                console.log(response)
                this.setSaveStatusSubjectGrade (index, 'saveSuccess')
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSaveStatusSubjectGrade (index, 'saveError')
            }
        },

        setSaveStatus (field, status = 'saving') {
            console.log(field);
            this.fields.forEach(value => {
                if(value.model == field.model){
                    Object.keys(field.saveStatus).forEach(key => {
                        if(key == status) field.saveStatus[key] = true;
                        else field.saveStatus[key] = false;
                    })
                }
            })
            console.log(status);
        },

        setSaveStatusSubjectChoice (choice, line, status) {
            console.log('save subject choice');
            if(choice == 1){
                this.subjectChoices1.forEach(value => {
                    if(value.line == line){
                        Object.keys(value.saveStatus).forEach(key => {
                            value.saveStatus[key] = false;
                            if(key == status){
                                value.saveStatus[key] = true;
                            }
                        })
                    }
                })
            }
            else if(choice == 2){
                this.subjectChoices2.forEach(value => {
                    if(value.line == line){
                        Object.keys(value.saveStatus).forEach(key => {
                            value.saveStatus[key] = false;
                            if(key == status){
                                value.saveStatus[key] = true;
                            }
                        })
                    }
                })
            }
        },

        setSaveStatusSubjectGrade (index, status) {
            Object.keys(this.subjects[index].saveStatus).forEach(key => {
                this.subjects[index].saveStatus[key] = false;
                if(key == status){
                    this.subjects[index].saveStatus[key] = true;
                }
            })
        },

        numberOnly($event){            
            if(!/\d/.test($event.key)) return $event.preventDefault();
        },

        displayApplicationForm () {
            this.src = process.env.VUE_APP_API_URI + "/api/sixth-form-application-form/" + 
            this.recordApplication.application_id + "/" +
            this.recordApplication.year;
            this.dialogReport = true;
        },

        closeRegistrationForm () {
            console.log('close registration form');
            this.dialogReport = false;
            this.overlay = false;
            this.src = '';
        },

        async showInstructions () {
            this.overlay = true;
            try {
                const { data } = await this.getInstructionsURL();
                this.src = data;
                this.dialogReport = true;
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            // this.src = process.env.VUE_APP_API_URI + "/api/sixth-form-application-instructions";
            // this.dialogReport = true;
            this.overlay = false;
        },

        async showPrerequisites () {
            this.overlay = true;
            try {
                const { data } = await this.getPrerequisitesURL();
                this.src = data;
                this.dialogReport = true;
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },

        closeApplication () {
            sessionStorage.clear();
            this.$router.replace('/');
        },

        submitApplicationForm () {
            this.dialogSubmit = true;
        },

        toUpperCase (props) {
            console.log(props);
            return null;
        }
    }
   
}
</script>

<style scoped>
    ::v-deep .theme--light.v-btn.v-btn--outlined.v-btn--text{
        position: fixed;
        z-index: 2;
    }

    ::v-deep .v-btn--fab.v-size--small.v-btn--absolute.v-btn--top {
        top: 25px;
    }

    ::v-deep .uppercase-input {
        text-transform: uppercase;
    }

    svg {
        width: 100px;
        display: block;
        margin: 40px auto 0;
    }

    .path {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
    }

    .path.circle {
        -webkit-animation: dash 0.9s ease-in-out;
        animation: dash 0.9s ease-in-out;
    }

    .path.line {
        stroke-dashoffset: 1000;
        -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
        animation: dash 0.9s 0.35s ease-in-out forwards;
    }

    .path.check {
        stroke-dashoffset: -100;
        -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
        animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }

    @-webkit-keyframes dash {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes dash {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    @-webkit-keyframes dash-check {
        0% {
            stroke-dashoffset: -100;
        }
        100% {
            stroke-dashoffset: 900;
        }
    }

    @keyframes dash-check {
        0% {
            stroke-dashoffset: -100;
        }
        100% {
            stroke-dashoffset: 900;
        }
    }
</style>
